module.exports = __webpack_public_path__ + "Roboto-BoldItalic.d23d5bdadc495f12ef69.ttf";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-BoldItalic.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-BoldItalic.ttf
// module chunks = 34